module.exports = __webpack_public_path__ + "img/hwy.10442f76.png";